import { TelemetryService } from "./telemetry.service";
import { TelemetrySession } from "./telemetry/telemetry.session";

export const AI_CATEGORY = "AI";

export type AiFeature =
    | "ExpressScheduling"
    | "Search"
    | "PricingFormula"
    | "FormWorkflowBuilder"
    | "FormEditor"
    | "WorkflowActionMap";

export type AiEventType = TelemetrySession.LifecycleEvent | "CompleteSave" | "Error";

export class AiTelemetry {
    static track(feature: AiFeature, eventType: AiEventType) {
        return TelemetryService.sendWithSub(AI_CATEGORY, feature, eventType);
    }

    static createSession(feature: AiFeature): TelemetrySession {
        return new TelemetrySession(AI_CATEGORY, feature);
    }
}
